import React from "react";
import { Card, Form, Spinner } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PrimaryButton from "../../components/PrimaryButton";
import usePromotionsViewController from "../../viewControllers/PromotionsViewController";

const Promotions = () => {
  const { loading, editedPromotions, setEditedPromotions, updatePromotions } =
    usePromotionsViewController();

  if (loading) {
    return <Spinner className="mt-5" />;
  }

  return (
    <div className="container-fluid p-3">
      <Card style={{ padding: "30px", width: "100%", height: "auto" }}>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            updatePromotions();
          }}
          className="mt-4 mb-4 px-4"
        >
          <h3>Promotions</h3>
          <div className="editor-container">
            <ReactQuill
              value={editedPromotions}
              onChange={setEditedPromotions}
              modules={editorModules}
              formats={editorFormats}
            />
          </div>
          <PrimaryButton
            type="submit"
            text={"Save"}
            className="mt-5 width-auto save-btn"
          />
        </Form>
      </Card>
    </div>
  );
};

const editorModules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "bullet" }],
  ],
};

const editorFormats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
];

export default Promotions;
